import React from "react";

/**
 * Rollerin kullanıcıya gösterilen adı ve rengi — tek kaynak.
 *
 * Bu eşleme daha önce yalnız Kullanıcılar tablosunda yaşıyordu; Kullanıcı Bilgileri
 * ekranı da aynı görünümü kullandığı için buraya taşındı. İki ekranın ayrı kopyalar
 * tutması, rol adları veya renkler değiştiğinde sessizce farklılaşmalarına yol açardı.
 *
 * Not: `constants/roles.js` içindeki USER_ROLE_LABEL_MAP form/seçim listelerinde
 * kullanılan BÜYÜK HARFLİ teknik etiketleri verir ("FİRMA ADMIN"). Buradaki
 * adlar ise son kullanıcıya gösterilen okunabilir adlardır ("Firma Yöneticisi").
 */

const NAVY = "#221C5D";

export const translateRole = (r) => {
    switch (r) {
        case "ROLE_SUPER_ADMIN": return "Süper Yönetici";
        case "ROLE_COMPANY_ADMIN": return "Firma Yöneticisi";
        case "ROLE_COMPANY_ACCOUNTANT": return "Firma Muhasebecisi";
        case "ROLE_COMPANY_SALESPERSON": return "Firma Plasiyer";
        case "ROLE_COMPANY_CASHIER": return "Firma Kasa Sorumlusu";
        case "ROLE_ACCOUNT_ADMIN": return "Cari/Bayi Yönetici";
        case "ROLE_ACCOUNT_ACCOUNTANT": return "Cari/Bayi Muhasebe";
        case "ROLE_USER": return "Kullanıcı";
        case "ROLE_MODERATOR": return "Moderatör";
        default: return r?.replace?.(/^ROLE_/, "") || r || "-";
    }
};

export const roleSolidColor = (r) => {
    switch (r) {
        case "ROLE_SUPER_ADMIN": return "#E07A7A";
        case "ROLE_COMPANY_ADMIN": return "#71C29B";
        case "ROLE_COMPANY_ACCOUNTANT": return "#7FCDE3";
        case "ROLE_ACCOUNT_ADMIN": return NAVY;
        case "ROLE_ACCOUNT_ACCOUNTANT": return "#F2C96D";
        case "ROLE_USER": return "#7AA7F5";
        case "ROLE_MODERATOR": return "#F0A46B";
        default: return "#B0B7C3";
    }
};

/** Tek rol rozeti. */
export const RoleBadge = ({ role, className = "" }) => (
    <span
        className={`badge border-0 ${className}`}
        style={{
            borderRadius: 999,
            padding: ".35rem .5rem",
            backgroundColor: roleSolidColor(role),
            color: "#fff",
        }}
    >
        {translateRole(role)}
    </span>
);

/** Birden fazla rol için rozet dizisi. */
export const RoleBadges = ({ roles = [] }) => (
    <>
        {roles.map((r, i) => (
            <RoleBadge key={i} role={r} className="me-1" />
        ))}
    </>
);
